import React, { useState, MouseEvent } from 'react';
import WaiverReportSummary from './WaiverReportSummary';
import WaiverMatchesByAirline from './WaiverMatchesByAirline';
import WaiverMatchesByAirport from './WaiverMatchesByAirport';
import '../../../styles/modules/report-results.less';

interface WaiverReportResultsProps {
  report: {
    summary: any;
    waiversByAirlineAndMonth: any;
    waiverMatchesByAirlineAndMonth: any;
    waiversByAirportAndMonth: any;
    waiverMatchesByAirportAndMonth: any;
  };
  onChartView?: () => void;
}

const WaiverReportResults: React.FC<WaiverReportResultsProps> = ({ report, onChartView }) => {
  const [activeTab, setActiveTab] = useState<string>('summary');

  const handleTabChange = (tab: string, event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    setActiveTab(tab);
    if (onChartView) {
      onChartView();
    }
  };

  return (
    <div className="report-results-data">
      <ul className="nav nav-tabs">
        <li className={activeTab === 'summary' ? 'active' : ''}>
          <a href="#" onClick={(e) => handleTabChange('summary', e)}>
            Summary
          </a>
        </li>
        <li className={activeTab === 'byAirline' ? 'active' : ''}>
          <a href="#" onClick={(e) => handleTabChange('byAirline', e)}>
            Waivers By Airline
          </a>
        </li>
        <li className={activeTab === 'byAirport' ? 'active' : ''}>
          <a href="#" onClick={(e) => handleTabChange('byAirport', e)}>
            Waivers By Airport
          </a>
        </li>
      </ul>
      <div className="tab-content">
        {activeTab === 'summary' && (
          <WaiverReportSummary summary={report.summary} />
        )}
        {activeTab === 'byAirline' && (
          <WaiverMatchesByAirline
            waivers={report.waiversByAirlineAndMonth}
            tripMatches={report.waiverMatchesByAirlineAndMonth}
          />
        )}
        {activeTab === 'byAirport' && (
          <WaiverMatchesByAirport
            waivers={report.waiversByAirportAndMonth}
            tripMatches={report.waiverMatchesByAirportAndMonth}
          />
        )}
      </div>
    </div>
  );
};

export default WaiverReportResults;